module.exports = __webpack_public_path__ + "a8a10a3e/img/rename-icon.de4e673d.svg";